<template>
<!-- 主页 -->
    <div>
        <div class="homePage">
            <!-- 主图 -->
            <div class="homePageLarge">
                <div class="carouselImg">
                    <div @mousedown="imgDown"  @mouseup="imgUp" id="imgMask"></div>
                    <div class="cimgDiv">
                        <img loading="lazy" class="cimg" v-for="(item,index) in carouselList" :key="index" :src="item.imgUrl">
                    </div>
                </div>
                <div class="cutPage">
                    <div v-for="(item,index) in carouselList" :key="index" :class="imgIdx == index ? 'divBackColor':''" @mouseout="carouseOut" @mouseover="carouseOver(index)">
                        <!-- 第一张 -->
                    </div>
                </div>
            </div>
            <!-- 关于胤石 -->
            <div class="aboutYinShiDiv">
                <div class="aboutYinShi">
                    <p>关于胤石</p>
                    <span></span>
                    <div class="YinShiIntroduce-One" :title="aboutYinShi.aboutYinShiInfo_One">
                        {{aboutYinShi.aboutYinShiInfo_One}}
                    </div>
                    <div class="YinShiIntroduce-Two" :title="aboutYinShi.aboutYinShiInfo_two">
                        {{aboutYinShi.aboutYinShiInfo_two}}
                    </div>
                    <div class="yinshiInfo">
                        <img loading="lazy" src="../assets/img/ljgd.png" >
                        <router-link to='/companyProfile'>了解更多</router-link>
                    </div>
                </div>
                <div class="YinShiImg">
                    <img loading="lazy" src="../assets/img/homePage/gongsishouye_05.jpg" >
                </div>
            </div>
            <!-- 产业链 -->
            <div class="IndustrialChainDiv" >
                <div class="allTitle">
                    <p>产业链</p>
                    <span></span>
                    <div>专注为中国品牌出海提供定制化、端到端的全渠道服务</div>
                </div>
                <div class="diserviceDiv">
                    <!-- class="wow fadeInUp storeAgentOperation" -->
                    <div class="wow fadeInUp storeAgentOperation">
                        <div><img loading="lazy" src="@/assets/img/homePage/gongsishouye_daiyunying.png"></div>
                        <div>店铺代运营</div>
                        <div :title="diserviceDiv.storeAgentOperationText" class="textHide"><span v-html="diserviceDiv.storeAgentOperationText"></span></div> 
                        <div><router-link to='/industrialChain/serviceContent'>了解更多</router-link></div>                       
                    </div>
                    <!-- class="wow fadeInUp digitalMarketing" data-wow-delay=".3s" -->
                    <div class="wow fadeInUp digitalMarketing" data-wow-delay=".3s">
                        <div><img loading="lazy" src="@/assets/img/homePage/gongsishouye_shuziyingxiao.png"></div>
                        <div>数字营销</div>
                        <div :title="diserviceDiv.digitalMarketingText" class="textHide"><span v-html="diserviceDiv.digitalMarketingText"></span></div>  
                        <div><router-link to='/industrialChain/digitalMarketing'>了解更多</router-link></div>                      
                    </div>
                    <!-- class="wow fadeInUp ITSolutions" data-wow-delay=".6s" -->
                    <div class="wow fadeInUp ITSolutions" data-wow-delay=".6s">
                        <div><img loading="lazy" src="@/assets/img/homePage/gongsishouye_ITjiejuefangan.png"></div>
                        <div>IT解决方案</div>
                        <div :title="diserviceDiv.ITSolutionsText" class="textHide"><span v-html="diserviceDiv.ITSolutionsText"></span></div> 
                        <div><router-link to='/industrialChain/ITSolutions'>了解更多</router-link></div>                  
                    </div>
                </div>
            </div>
            <!-- 核心优势 -->
            <div class="coreAdvantagesDiv">
                <div class="allTitle">
                    <p>核心优势</p>
                    <span></span>
                    <div>专注为中国品牌出海提供定制化、端到端的全渠道服务</div>
                </div>
                <div class="coreAdvantagesInfo wow up" data-wow-delay=".6s">
                    <div class="coreAdvantagesInfo_One">
                        <div class="coreText">
                            <div>全渠道</div>
                            <div :title="coreAdvantagesText.omniChannel" class="textHide">{{coreAdvantagesText.omniChannel}}</div>
                            <div class="coreTextBorder"></div>
                        </div>
                        <div class="coreImg"><img loading="lazy" src="@/assets/img/homePage/gongsishouye_11.jpg"></div>
                    </div>
                    <div class="coreAdvantagesInfo_Two">
                        <div class="coreImg"><img loading="lazy" src="@/assets/img/homePage/gongsishouye_14.jpg"></div>
                        <div class="coreText">
                            <div>技术与创新</div>
                            <div :title="coreAdvantagesText.technologyAndInnovation" class="textHide">{{coreAdvantagesText.technologyAndInnovation}}</div>
                            <div class="coreTextBorder"></div>
                        </div>

                    </div>
                </div>
            </div>
            <!-- 专业团队 -->
            <div class="professionalTeamDivDiv">
                <div class="professionalTeamDiv">
                    <div class="professionalTeamTitle allTitle">
                        <p>专业团队</p>
                        <span></span>
                        <div>多年沉淀的经营团队，高效运作，通力协作，提供专业的定制化运营服务</div>
                    </div>
                    <div class="departmentCore">
                        <div class="RDCenter">  <!--研发中心 -->
                            <div class="RDCenterTitle">研发中心</div>
                            <div class="RDCenterText textHide">由产品部、研发部、组成的跨境电商行业高规模IT团队,根据市场变化和客户需求,进行产品规划设计、新功能模块的开发及系统维护等</div>
                            <div class="RDCenterNum">20+</div>
                        </div>
                        <div class="marketingCenter">   <!--营销中心 -->
                            <div class="RDCenterTitle">营销中心</div>
                            <div class="RDCenterText textHide">由市场部和销售部组成。打造胤石品牌和行业口碑,为客户创造价值,为跨境行业树立标杆!</div>
                            <div class="RDCenterNum">10+</div>
                        </div>
                        <div class="operationCenter">   <!--运营中心 -->
                            <div class="RDCenterTitle">运营中心</div>
                            <div class="RDCenterText textHide">由实施部、客服部、技术部和培训部组成的。以客户服务为中心。运营中心服务宗旨是以专业及时、高效的服务帮助客户的系统使用。</div>
                            <div class="RDCenterNum">40+</div>
                        </div>
                        <div class="supportCenter"> <!--支持中心 -->
                            <div class="RDCenterTitle">支持中心</div>
                            <div class="RDCenterText textHide">由财务部、人事部、行政部和法务部组成。为其它部门提供高质量得服务支撑,保证公司内部人、财物的有效管理。</div>
                            <div class="RDCenterNum">10+</div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 新闻动态 -->
            <div class="dynamicNewsDiv">
                <div class="allTitle">
                    <p>新闻动态</p>
                    <span></span>
                    <!-- <div>专注为中国品牌出海提供定制化、端到端的全渠道服务</div> -->
                </div>
                <div class="dynamicNewsImgAndTextAll">
                    <div class="dynamicNewsImgAndText" >
                        <div class="wow right dynamicNewsImg">
                            <img loading="lazy" :src="firstNews.coverImageUrl" @click="jumpPage(firstNews.id)" class="hoverA">
                        </div>
                        <div class="wow right dynamicNewsText">
                            <div class="dnText" @click="jumpPage(firstNews.id)">
                                <p class="textHide"><a class="hoverA" style="font-weight: 600;">{{firstNews.title}}</a></p>
                                <div class="textHide"><a class="hoverA">{{firstNews.introduce}}</a></div>
                            </div>
                            <div class="dnDate">
                                <span>{{firstNews.year}}</span>
                                <span></span>
                                <span>{{firstNews.day}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="dynamicNewsTextAll" v-if="rightListNews">
                        <div class="wow left dynamicNewsText" :data-wow-delay="0.1*(index+1)+'s'" v-for="(item,index) in rightListNews" :key="index">
                            <div class="dnText" @click="jumpPage(item.id)">
                                <p class="textHide"><a class="hoverA" style="font-weight: 600;">{{item.title}}</a></p>
                                <div class="textHide"><a class="hoverA">{{item.introduce}}</a></div>
                            </div>
                            <div class="dnDate">
                                <span>{{item.year}}</span>
                                <span></span>
                                <span>{{item.day}}</span>
                            </div>
                        </div>
                    </div>
                    <div class="dynamicNewsTextAll" v-else>
                        <div class="dnDate">
                            <span style="color:red;float:left;">暂无多的新闻！</span>
                        </div>
                    </div>
                </div>
                
            </div>
        </div>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'
// import { WOW } from 'wowjs';
// getListNews              查询新闻
// listEnableSwiperInfo     查询启用轮播图信息
import {getListNews,listEnableSwiperInfo} from '@/api'

export default {
    name: 'YinshiOffcialwebsiteHomePage',
    data() {
        return {
            //  关于胤石
            aboutYinShi:{
                aboutYinShiInfo_One:'胤石科技从一家销售额过亿的品牌卖家，过渡到专注为中国品牌出海提供定制化、端到端的全渠道服务。涉及店铺运营、数字营销、IT解决方案、等内容。我们的业务覆盖从品牌独立站，到线上购物平台亚马逊、eBay、速卖通、沃尔玛、Wish、Shopee等全渠道的构建。我们始终秉持科技优先原则，基于互联网大数据分析，不断研发运营技术，为企业定制品牌出海方案的同时，赋能品牌自我发展。',
                // aboutYinShiInfo_two:'每个企业主都有一个品牌梦,当国内竞争愈演愈烈的时候，品牌出海无疑为企业主提供了一个绝好的弯道超车的机会。胤石科技服务的客户以中小品牌为主,经验缺乏、技术缺乏、资金缺乏、是挡在这些中小企业主"走出去"面前的三座大山，胤石凭借多年在品海出海领域的经验积累,力争以最优惠的价格为企业提供最靠谱的服务。为此我们提供了多种 ......',
                aboutYinShiInfo_two:'每个企业主都有一个品牌梦,当国内竞争愈演愈烈的时候，品牌出海无疑为企业主提供了一个绝好的弯道超车的机会。胤石科技服务的客户......',
            },
            // 产业链下面的文本
            diserviceDiv:{
                storeAgentOperationText:'提供针对品牌电商的一站式解决方案和服务，包括网店和购物网站的建设、店站运营、数字营销、视觉设计、品牌推广、订单管理、仓储物流、订单履约及客户服务等。抓牢全球开店红利增长，助力企业品牌出海。',
                digitalMarketingText:'以全渠道销售配合全渠道营销，领先的品销合一的实践者，为品牌客户实现从策略输出到效果执行的全整合营销服务。(站外推广、站外SNS社交媒体、网络红人定制推荐、专业博主产品软文刨<br>析、品牌官网精准定位）',
                ITSolutionsText:'企业IT信息系统整体搭建<br>企业跨境ERP定制开发<br>智能化仓库管理<br>企业私有云及VPS方案输出，保障账户安全<br>可视化供应链管理系统，数字化赋能供应链上下游',
            },
            // 核心优势
            coreAdvantagesText:{
                omniChannel:'在不同的渠道，品牌都希望消除边界，提供无缝的消费者购物场景，即无处不在、无时不在的商品提供、服务体验和客户权益。而这需要强大的全渠道服务体系保证，包括全渠道的店站管理、跨渠道零售运营能力、整合的库存体系以及贸易和结算系统。作为全渠道解决方案的领先者，胤石已经成功帮助品牌实施全渠道策略，并将带领更多的品牌实现数字化转型、助力品牌升级',
                technologyAndInnovation:'今天的品牌电商发展推动了整体的零售模式变革，这一变革又引发了技术的变革，产生了巨大的创新空间。胤石持续在零售系统、数据采集和分析、图像处理和识别、云计算等技术研发和应用领域投入，并坚信技术和创新会对品牌电商的发展产生本质的影响。'
            },
            // 第一个新闻
            firstNews:{},
            // 右边的新闻新闻
            rightListNews:[],
            // 轮播图列表
            carouselList:[
                {url:require('../assets/img/homePage/01.jpg')},
                {url:require('../assets/img/homePage/02.jpg')},
                {url:require('../assets/img/homePage/03.jpg')},
                {url:require('../assets/img/homePage/04.jpg')},
            ],
            // 小圆点下标 当前显示的图片
            imgIdx:0,
            // 定时器轮播图
            setIntval:null,
            // 当前鼠标距离屏幕左侧的位置
            clientX:{},
            // 当前已经移动的left
            left:0,
            // 鼠标已经移动的距离
            movedist:0,
            // 节流阀
            flag:true,
            // 当前显示图片的下标
            num:0,
            // 最后一张图片时候过度到第二张
            dntImg:0,
            upnImg:0,
            // img left
            imgleftIntval:null,//轮播图
        };
    },
    // 离开当前页面
    beforeDestroy(){
        this.$store.state.navBackground = '#20407f'
        clearInterval(this.setIntval)

    },
    mounted() {
        
    },

    methods: {
        ...mapMutations(['GoTop']),
        // 查询新闻
        async selectGetListNews(){
            let res = await getListNews({page:1,pageSize:10});
            if(res.code == 200){
                res.data.forEach(item => {
                    item.year = item.newsDate.split('-')[0]
                    item.day = item.newsDate.split('-')[1]+'-'+item.newsDate.split('-')[2]
                })
                if(res.data){
                    this.firstNews = res.data[0]
                }
                if(res.data.length > 1){
                    res.data.forEach((item,index) => {
                        if(index > 0){
                            if(this.rightListNews.length >= 4){
                                return
                            }
                            this.rightListNews.push(item)
                        }
                    })
                }else{
                    this.rightListNews = []
                }   
                // this.$nextTick(() => {
                //     new this.$WOW.WOW().init()
                // });
            }
        },
        //查询轮播图 
        async selectSwiper(){
            let res = await listEnableSwiperInfo();
            this.carouselList = res.data
            // 轮播图把第一张克隆，然后添加到最后一张的后面
            this.$nextTick(() => { 
                var cimg = document.getElementsByClassName('cimgDiv')[0]
                let child = cimg.children[0].cloneNode(true);
                cimg.appendChild(child);
            })
        },
        // 跳转到新闻详情页面
        jumpPage(id){
            this.$router.push({path:'/dynamicNews/newsDetails',query:{id:id}});
        },
        // 轮播图动画
        // 动画函数：实现缓动动画效果
        animate(obj, target, callback) {
            // 清除之前的定时器，避免多个动画冲突
            clearInterval(obj.timer);
            // 设置新的定时器
            obj.timer = setInterval(function () {
                // 计算步长，缓动效果，越接近目标步长越小
                let step = (target - obj.offsetLeft) / 10;
                // 向上取整或向下取整，保证动画能到达目标位置
                step = step > 0 ? Math.ceil(step) : Math.floor(step);
                // 如果当前位置等于目标位置，动画结束
                if (obj.offsetLeft === target) {
                    clearInterval(obj.timer); // 清除定时器
                    if (callback) callback(); // 执行回调函数
                    return;
                }
                // 设置新的left值，实现动画
                obj.style.left = obj.offsetLeft + step + 'px';
            }, 15); // 每15毫秒执行一次
        },
        // 开启轮播图
        carouselChart(){
            this.setIntval = setInterval(() => {
                this.dowImg()
            }, 5500);
        },
        // 上一张图片
        upImg(){
            var that = this
            var cimg = document.querySelector('.cimgDiv')
            if (this.flag) {
                // this.flag = false;
                if (this.num == 0) {
                    this.num = cimg.children.length - 1;  // 当轮播图为第一张图时，num设为最后一张图的index，之后再减一
                    if(Math.abs(this.upnImg)){
                        cimg.style.left = '-'+ this.upnImg + 'px';  // 先切换到最后一张图，之后再调用动画函数到实际倒数第二图
                    }else{
                        cimg.style.left = -this.num * cimg.offsetWidth + 'px';  // 先切换到最后一张图，之后再调用动画函数到实际倒数第二图
                    }
                }
                this.num--;
                this.animate(cimg, -this.num * cimg.offsetWidth, function () {
                    that.flag = true;
                });
                this.imgIdx--;
                if (this.imgIdx == -1)  // 当小圆圈在第一个位置时，点击左移，circle-1，此时circle为-1
                    this.imgIdx = cimg.children.length - 2;
            }
        },
        // 下一张图片
        dowImg(){
            var that = this
            var cimg = document.querySelector('.cimgDiv')
            if (this.flag) {
                // this.flag = false;  // 未完成轮播动画，不能轮播，设置为false
                if (this.num == cimg.children.length - 1) {
                    if(Math.abs(this.dntImg)){
                        cimg.style.left = '-'+this.dntImg+'px';  // 当点击到最后一个图片时，即和第一幅图相同的那张，num为ul.children.length-1,先切换到第一张(很快),执行动画切换到第二张
                    }else{
                        cimg.style.left = 0;  // 当点击到最后一个图片时，即和第一幅图相同的那张，num为ul.children.length-1,先切换到第一张(很快),执行动画切换到第二张
                    }
                    this.num = 0;  // num重新设为0，后面再加1
                }
                this.num++;
                this.animate(cimg, -this.num * cimg.offsetWidth, function () {
                    that.flag = true;  // 将flag设置为true，可以再次点击轮播
                });
                this.imgIdx++;
                if (this.imgIdx == cimg.children.length - 1)  // 当小圆圈移动到最后，点击右移，circle+1,此时circle为ol.children.length
                    this.imgIdx = 0;
                // 最后一张移到第一张 就是最后一张(第一张)移到第二张
                this.dntImg = 0
            }
        },
        // 小圆点 切换图片
        carouseOver(idx){
            var cimg = document.getElementsByClassName('cimgDiv')[0]
            // console.log(cimg)
            this.animate(cimg,-idx*cimg.offsetWidth)
            this.num = this.imgIdx = idx
            // 鼠标移上去关闭轮播图
            clearInterval(this.setIntval)
        },
        // 鼠标移走开启轮播图
        carouseOut(){
            this.carouselChart()
        },
        //鼠标按下
        imgDown(e){
            // 鼠标点击关闭轮播图
            clearInterval(this.setIntval)
            var cimg = document.getElementsByClassName('cimgDiv')[0]
            clearInterval(cimg.timer);
            // 当前鼠标距离左侧
            this.clientX = e.clientX
            // 当前图片的左侧边距
            this.left = getComputedStyle(cimg)["left"].split('px')[0]
            // // 给图片添加鼠标移动事件
            document.getElementById('imgMask').addEventListener('mousemove',this.imgMover)
        },
        //鼠标移动
        imgMover(event){
            var mouseLeft= event.clientX;
            var cimg = document.getElementsByClassName('cimgDiv')[0]
            //当前鼠标移动的距离
            var cx = this.clientX - mouseLeft;
            this.movedist = cx
            var mlNub = this.left - cx
            // console.log(this.movedist)
            // 移动图片
            if(this.num == cimg.children.length -1){    // 最后一张移到第一张 就是最后一张(第一张)移到第二张
                if(this.movedist > 0){
                    cimg.style.left = '-'+this.movedist+'px'
                    this.dntImg = this.movedist
                }else{
                    cimg.style.left = mlNub+'px'
                }
            }else if(this.num == 0){    //第一张移到最后一张
                if(this.movedist > 0){
                    cimg.style.left = mlNub+'px'
                }else{
                    var nm = (((cimg.children.length-1)*cimg.offsetWidth)+this.movedist)
                    cimg.style.left = '-'+nm+'px'
                    this.upnImg = nm
                }
            }else{
                cimg.style.left = mlNub+'px'
            }
        },
        //鼠标松开
        imgUp(){
            var that = this
            // 给图片添加鼠标移动事件
            var cimg = document.getElementsByClassName('cimgDiv')[0]
            if(this.movedist > 0 && this.movedist > (cimg.offsetWidth/5)*2){
                this.dowImg()
            }else if(this.movedist < 0 && (this.movedist*-1) > (cimg.offsetWidth/5)*2){
                this.upImg()
            }else{
                // 鼠标松开
                if(this.num == cimg.children.length -1){    // 最后一张移到第一张 就是最后一张(第一张)移到第二张
                    if(this.movedist > 0){
                        this.num = 0
                    }else{
                        this.num = cimg.children.length-1
                    }
                }else if(this.num == 0){    //第一张移到最后一张
                    if(this.movedist < 0){
                        this.num = cimg.children.length-1
                    }else{
                        this.num = 0
                    }
                }
                this.animate(cimg, -this.num * cimg.offsetWidth, function () {
                    that.flag = true;
                });
            }
            document.getElementById('imgMask').removeEventListener('mousemove',this.imgMover)
            this.carouselChart()
        },
    },
    created(){
        this.$store.state.currentRouter = this.$route.path  //获取当前页面路由
        this.$store.state.navBackground = 'transparent'
        this.GoTop()
        // 查询轮播图
        this.selectSwiper()
        // 查询新闻
        this.selectGetListNews()
        // 开启轮播图
        this.carouselChart()
    }
};
</script>

<style lang="scss" scoped>
.homePage{
    // 主图
    .homePageLarge{
        position: relative;
        // 图片
        .carouselImg{
            display: flex;
            overflow: hidden;
            margin-top: -84px;
            // transform-style: preserve-3d;
            // transform: perspective(500px) rotateX(0deg);
            #imgMask{
                position: absolute;
                // background: #ffffff00;
                width: 100%;
                height: 100%;
                cursor: pointer;
                z-index: 1;
            }
            .cimgDiv{
                display: flex;
                position: relative;
                img{
                    flex-shrink:0;
                    width: 100%;
                    height: 980px;
                    position: relative;
                    z-index: -1;
                }
            }
            
        }
        // 换页
        .cutPage{
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            bottom: 60px;
            display: flex;
            margin-left: -20px;
            z-index: 9;
            div{
                margin-left: 20px;
                width: 10px;
                height: 10px;
                opacity: 0.2;
                background: #000000;
                border-radius: 50%;
                cursor: pointer;
                transition:.2s;
            }
            div:hover{
                background: #ffffff;
            }
            .divBackColor{
                background: #ffffff;
            }
        }
    }
    // 关于胤石
    .aboutYinShiDiv{
        padding:70px 270px;
        display: flex;
        justify-content: space-between;
        // 关于胤石标题
        .aboutYinShi{
            p{
                height: 22px;
                font-size: 22px;
                font-weight: 700;
                color: #333333;

            }
            span{
                display: inline-block;
                width: 71px;
                height: 2px;
                background: #7492d7;
            }
            // 胤石介绍
            .YinShiIntroduce-One,.YinShiIntroduce-Two{
                margin-top: 30px;
                width: 647px;
                font-size: 16px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                text-align: left;
                color: #666666;
                line-height: 28px;
                overflow: hidden;
                display: -webkit-box;
                -webkit-box-orient:vertical;
                -webkit-line-clamp:5;
            }
            .yinshiInfo{
                display: flex;
                align-items: center;
                margin-top: 99px;
                img{
                    width: 30px;
                    height: 14px;
                    color:#7492D7;
                }
                a{
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    color: #7492d7;
                    margin-left:15px;
                    margin-top:-1px;
                    cursor: pointer;
                }
            }
        }
        .YinShiImg{
            width: 663px;
            height: 424px;
            img{
                width:100%;
                height: 100%;
            }
        }
    }
    // 产业链
    .IndustrialChainDiv{
        padding-bottom: 70px;
        // 产业链标题
        .IndustrialChain{
            text-align: center;
            p{
                font-size: 22px;
                font-weight: 700;
                color: #333333;
            }
            span{
                width: 29px;
                height: 2px;
                background: #0f244f;
                display: inline-block;
                position: relative;
                top: -8px;
            }
            div{
                font-size: 12px;
                font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                font-weight: 400;
                color: #b5b5b5;
            }
        }
        // 产业链下的其他
        .diserviceDiv{
            background: url(../assets/img/homePage/gongsishouye_08.jpg);
            background-size:100% 100%;
            padding:50px 270px;
            display: flex;
            justify-content: space-between;
            margin-top: 50px;
            // 店铺代运营 数字营销  解决方案
            .storeAgentOperation,.digitalMarketing,.ITSolutions{
                // width: 440px;
                // height: 500px;
                width: 360px;
                height: 410px;
                background: #ffffff;
                padding:50px 40px 40px 40px;
                display: flex;
                flex-direction: column;
                align-items: center;
                position: relative;
                // 小图片
                div:nth-child(1){
                    img{
                        width:45px;
                        height:45px;
                    }
                }
                // 标题
                div:nth-child(2){
                    font-size: 20px;
                    font-weight: 400;
                    color: #000000;
                    margin-top: 20px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                }
                // 文本信息
                div:nth-child(3){
                    width: 365px;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #666666;
                    line-height: 32px;
                    margin-top: 50px;
                    -webkit-line-clamp:7;
                }
                // 了解更多
                div:nth-child(4){
                    position: absolute;
                    bottom: 40px;
                    a{
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        font-weight: 400;
                        color: #7492d7;
                        cursor: pointer;
                    }
                }
            }
            .digitalMarketing{
                // 小图片
                div:nth-child(1){
                    img{
                        width:40px;
                        height:43px;
                    }
                }
            }
            .ITSolutions{
                // 小图片
                div:nth-child(1){
                    img{
                        width:43px;
                        height:43px;
                    }
                }
            }
        }
    }
    // 核心优势
    .coreAdvantagesDiv{
        // 图片和描述
        .coreAdvantagesInfo{
            padding:50px 270px;
            padding-bottom: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
            // 四个区块的大小
            .coreAdvantagesInfo_One,.coreAdvantagesInfo_Two{
                display: flex;
                // 图片
                .coreImg{
                    width: 690px;
                    height: 361px;
                    overflow: hidden;
                    cursor: pointer;
                    img{
                        width:100%;
                        height:100%;
                        transition:.2s;
                    }
                    img:hover{
                        transform: scale(1.03);
                    }
                }
                // 文本信息
                .coreText{
                    width: 620px;
                    height: 291px;
                    background: #f3f3f3;
                    padding:70px 35px 0px 35px;
                    position: relative;
                    // 标题
                    div:nth-child(1){
                        font-size: 18px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        font-weight: 400;
                        color: #000000;
                    }
                    // 内容
                    div:nth-child(2){
                        margin-top: 15px;
                        padding-top: 25px;
                        // width: 560px;
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #666666;
                        line-height: 32px;
                        border-top: 2px solid #b5b5b5;
                    }
                    .coreTextBorder{
                        display: inline-block;
                        width: 14px;
                        background: #7492D7;
                        height: 2px;
                        position: absolute;
                        top:107.5px;
                    }
                }
            }
            
        }

    }
    // 专业团队
    .professionalTeamDivDiv{
        height: 596px;
        .professionalTeamDiv{
            padding: 50px 270px;
            padding-bottom: 70px;
            height: 260px;
            background: url(../assets/img/homePage/gongsishouye_17.jpg);
            background-size:100% 380px;
            // 标题
            .professionalTeamTitle{
                p{
                    color:#fff;
                    font-size: 26px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                }
                span::before{
                    content:'';
                    width: 46px;
                    height: 2px;
                    display: inline-block;
                    background: #ffffff;
                    position: absolute;
                    left: -11px;
                    z-index: 33;
                }
                span::after{
                    content:'';
                    width: 100px;
                    height: 1px;
                    display: inline-block;
                    background: #0f244f;
                    position: absolute;
                    left: -39px;
                }
                div{
                    color: #ffffff;
                    font-size: 18px;
                    font-weight: 400;
                }
            }
            // 各个部门的中心
            .departmentCore{
                display:flex;
                justify-content: center;
                margin-top:50px;
                // 大盒子
                .RDCenter,.marketingCenter,.operationCenter,.supportCenter{
                    width: 345px;
                    height: 439px;
                    margin-left: -1px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    position: relative;
                }
                .RDCenter,.operationCenter{
                    background: #f2f2f2;
                }
                .marketingCenter,.supportCenter{
                    background: #ebebeb;
                }
                // 标题
                .RDCenterTitle{
                    width: 109px;
                    height: 47px;
                    background: #7492d7;
                    border-radius: 5px;
                    line-height: 45px;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                    font-weight: 700;
                    text-align: center;
                    color: #ffffff;
                    margin-top:50px;
                }
                // 文本
                .RDCenterText{
                    margin-top: 70px;
                    padding: 0 30px;
                    font-size: 16px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #666666;
                    line-height: 32px;
                }
                // 数字
                .RDCenterNum{
                    position: absolute;
                    bottom: 50px;
                    font-size: 36px;
                    font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                    font-weight: 400;
                    text-align: center;
                    color: #3b589a;
                    line-height: 28px;
                }
            }
        }
    }
    // 新闻动态
    .dynamicNewsDiv{
        margin-top: 70px;
        padding:0 270px;
        padding-bottom: 70px;
        // 第一条新闻和图片
        .dynamicNewsImgAndTextAll{
            display: flex;
            justify-content: space-between;
            padding-top: 50px;
            .dynamicNewsImgAndText{
                // 图片
                .dynamicNewsImg{
                    width: 630px;
                    height: 423px;
                    cursor: pointer;
                    img{
                        width:100%;
                        height: 100%;
                    }
                }
            }
            // 新闻内容 
            .dynamicNewsText{
                width: 630px;
                height: 78px;
                margin-top: 30px;
                display: flex;
                justify-content: space-between;
                // 文本
                .dnText{
                    width: 532px;
                    cursor: pointer;
                    p{
                        font-size: 18px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                        font-weight: 700;
                        color: #333333;
                        -webkit-line-clamp:1;
                    }
                    div{
                        margin-top: 20px;
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        font-weight: 400;
                        text-align: left;
                        color: #666666;
                        line-height: 32px;
                        -webkit-line-clamp:2;
                    }
                }
                // 时间
                .dnDate{
                    width: 62px;
                    height: 78px;
                    border: 1px solid #3b589a;
                    border-radius: 5px;
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    span:nth-child(1){
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Bold;
                        font-weight: 700;
                        text-align: center;
                        color: #333333;
                        padding: 5px 0;
                        padding-bottom: 20px;
                    }
                    span:nth-child(2){
                        width: 29px;
                        height: 2px;
                        background: #0f244f;
                        display: inline-block;
                        position: relative;
                        top: -8px;
                    }
                    span:nth-child(3){
                        font-size: 16px;
                        font-family: Microsoft YaHei, Microsoft YaHei-Regular;
                        font-weight: 400;
                        text-align: center;
                        color: #333333;
                    }
                }
            }
            .dynamicNewsTextAll .dynamicNewsText{
                margin-top: 0px;
            }
            .dynamicNewsTextAll .dynamicNewsText:nth-child(n+2){
                margin-top: 72px;
            }
        }
        
    }
}
.hoverA:hover{
    text-decoration: underline;
}
</style>